import React from 'react';
function isIconRenderProp(func) {
  return !func.displayName &&
  // most function components and class components have a displayName, negate them
  !func.render &&
  // forwardRef doesn't require a display name, however it does include a render function, negate them
  typeof func === 'function' // at the very least we need to be a function
  ;
}

/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */
const IconRenderer = ({
  icon: Icon
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, isIconRenderProp(Icon) ? Icon({
    label: '',
    color: 'currentColor'
  }) : /*#__PURE__*/React.createElement(Icon, {
    label: "",
    color: 'currentColor'
  }));
};
export default IconRenderer;